/* global axios */
import ApiClient from './ApiClient';

class PlatformUpdatesAPI extends ApiClient {
    constructor() {
        super('platform_updates', { accountScoped: true });
    }

    getUpdates(page = 1) {
        return axios.get(this.url, { params: { page } });
    }

    getUnreadCount() {
        return axios.get(`${this.url}/unread_count`);
    }

    markAllRead() {
        return axios.post(`${this.url}/mark_all_read`);
    }
}

export default new PlatformUpdatesAPI();
